document.addEventListener('DOMContentLoaded', () => {
    const cardGalleries = document.querySelectorAll('[data-card-gallery]');
    if (!cardGalleries.length) return;

    cardGalleries.forEach((galleryContainer) => {
        let cachedData = null;
        let isLoading = false;

        galleryContainer.style.cursor = 'pointer';

        const openModal = (data, startIndex) => {
            if (typeof $.fancybox === 'undefined') return;

            $.fancybox.open(data, {
                loop: true,
                buttons: [
                    'slideShow',
                    'fullScreen',
                    'thumbs',
                    'zoom',
                    'close',
                ],
                thumbs: {
                    autoStart: true,
                    axis: 'x',
                },
                animationEffect: 'fade',
                animationDuration: 500,
                transitionEffect: 'slide',
                slideShow: {
                    autoStart: (data.length > 1),
                    speed: 5000,
                },
            }, startIndex);
        };

        galleryContainer.addEventListener('click', (event) => {
            const slide = event.target.closest('[data-slide-index], .swiper-slide');
            if (!slide || !galleryContainer.contains(slide)) return;

            const slideIndex = parseInt(slide.dataset.slideIndex, 10) || 0;
            const galleryLink = galleryContainer.dataset.cardGalleryLink;

            if (!galleryLink) return;

            if (cachedData) {
                openModal(cachedData, slideIndex);
                return;
            }

            if (isLoading) return;
            isLoading = true;

            fetch(galleryLink, {method: 'POST'})
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Ошибка ответа сервера');
                    }
                    return response.json();
                })
                .then((data) => {
                    cachedData = data;
                    openModal(cachedData, slideIndex);
                })
                .catch((error) => {
                    console.error('Ошибка загрузки галереи:', error);
                })
                .finally(() => {
                    isLoading = false;
                });
        });
    });
});
